<template>
  <div class="shpksq-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <div class="card-title">
            售后赔款
            <div class="search-mode">
              <input type="text" class="search-input" @keyup.enter="Search" placeholder="关键字搜索" v-model="search" />
              <el-button class="search-btn" icon="el-icon-search" @click="Search"/>
            </div>
          </div>
          <div class="card-content" >
            <el-row>
              <el-col :span="5">
                <ul class="group-filter">
                  <li :class="type===0?'active':''" @click="change(0)">待审核</li>
                  <li :class="type===1?'active':''" @click="change(1)">已通过</li>
                  <li :class="type===2?'active':''" @click="change(2)">已驳回</li>
                </ul>
              </el-col>
              <el-col :span="19" v-loading="loading">
                <el-table
                  :data="tableData"
                  :show-header="false"
                  :row-style="{cursor: 'pointer'}"
                  @row-click="openDetails"
                  style="width: 100%">
                  <el-table-column
                    label="订单号"
                    width="170"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===0" type="warning">待审核</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===1">审核通过</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===2" type="danger">审核驳回</el-tag>
                      <span style="margin-left: 6px;">{{scope.row.order_num}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="经销商"
                    width="120"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span><i class="el-icon-user"></i> {{scope.row.all_name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="原正单号"
                    width="130"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#99a9bf">原正单：</span>
                      <span>{{scope.row.product_num}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="详细地址"
                    min-width="160"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span><i class="el-icon-location-outline"></i> {{scope.row.address}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="申请时间"
                    width="170"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span><i class="el-icon-time"></i> {{scope.row.apply_time}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="申请人"
                    fixed="right"
                    width="120"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#99a9bf">申请人：</span>{{scope.row.apply_name}}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="赔款金额"
                    width="100"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin"></i> {{scope.row.money}}</span>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="售后赔款详情"
      :visible.sync="infoVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <table class="tcf-detail-table" v-loading="fullscreenLoading">
        <tr>
          <th>订单号</th>
          <td>{{infoData.orderNum}}</td>
          <th>原正单号</th>
          <td>{{infoData.beforenum}}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{infoData.delname}}</td>
          <th>客诉时间</th>
          <td>{{infoData.ordertime}}</td>
        </tr>
        <tr>
          <th>终端地址</th>
          <td colspan="3">{{infoData.address}}</td>
        </tr>
        <tr>
          <th>投诉内容</th>
          <td colspan="3">{{infoData.aftercontent}}</td>
        </tr>
        <tr>
          <th>返修单</th>
          <td colspan="3">
            <el-button type="text" size="small" @click="downFile(infoData.reworkid)" icon="el-icon-download">
              {{infoData.reworkname}}
            </el-button>
          </td>
        </tr>
        <tr>
          <th>判定单</th>
          <td colspan="3">
            <el-image
              style="width: 60px; height: 60px;"
              fit="cover"
              :preview-src-list="[infoData.decisionurl]"
              :src="infoData.decisionurl">
            </el-image>
          </td>
        </tr>
        <tr>
          <th>售后原因</th>
          <td colspan="3">{{infoData.reasonStr}}</td>
        </tr>
        <tr>
          <th>责任部门</th>
          <td colspan="3">{{deptRson}}</td>
        </tr>
        <tr>
          <th>责任车间</th>
          <td>{{infoData.resfactory}}</td>
          <th>售后赔款</th>
          <td><span style="color:#f56c6c;font-size: 16px;font-weight: 500;">{{infoData.amount}}</span>&nbsp;元</td>
        </tr>
        <tr>
          <th>售后备注</th>
          <td colspan="3">{{infoData.afterremark}}</td>
        </tr>
        <tr>
          <th>申请人</th>
          <td>{{infoData.username}}</td>
          <th>申请时间</th>
          <td>{{infoData.time}}</td>
        </tr>
        <tr v-if="infoData.mark!==0">
          <th>审核人</th>
          <td>{{infoData.auditname}}</td>
          <th>审核时间</th>
          <td>{{infoData.audittime}}</td>
        </tr>
        <tr v-if="infoData.mark===2">
          <th>驳回原因</th>
          <td colspan="3">{{infoData.rson}}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-if="infoData.mark===2" :loading="auditLoading" size="small" @click="audit">再次提交</el-button>
        <el-button size="small" @click="infoVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getAfterIndemnityList, getAfterIndemnityDetail, againAfterIndemnity } from '@/api/erp'
import { getFileInfo } from '@/api/pub'

export default {
  name: 'shpksq',
  computed: {
    user: getUser
  },
  data() {
    return {
      fullscreenLoading: false,
      search: '',
      type: 0,
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      infoVisible: false,
      infoData: [],
      auditLoading: false,
      deptRson: ''
    }
  },
  created() {
    this.getData()
  },
  methods: {
    change(n) {
      if (this.type === n) {
        return false
      }
      this.type = n
      this.getData()
    },
    Search() {
      if (this.search !== null && this.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        mark: this.type,
        content: this.search,
        page: this.currentPage,
        limit: this.pageSize,
        groupid: this.user.dGroupid,
        userid: this.user.dUserid,
        role: this.user.role
      }
      getAfterIndemnityList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      this.fullscreenLoading = true
      getAfterIndemnityDetail({ asiid: row.review_id }).then(response => {
        this.infoData = response.data
        let deptRson = ''
        for (const dept of this.infoData.depts) {
          switch (dept.groupnum) {
            case 0:
              deptRson += '设计、'
              break
            case 1:
              deptRson += '木工、'
              break
            case 2:
              deptRson += '油漆、'
              break
            case 3:
              deptRson += '包装、'
              break
            case 4:
              deptRson += '外协、'
              break
            case 5:
              deptRson += '客户、'
              break
            case 6:
              deptRson += '其它、'
              break
            default:
              deptRson += ''
          }
        }
        if (deptRson.endsWith('、')) {
          deptRson = deptRson.substr(0, deptRson.length - 1)
        }
        this.deptRson = deptRson
        this.fullscreenLoading = false
      }).catch(() => {
        this.fullscreenLoading = false
      })
      this.infoVisible = true
    },
    downFile(fileid) {
      getFileInfo({ fileid: fileid }).then(response => {
        /* this.$message({
          message: '返修单已下载',
          type: 'success'
        })*/
        const a = document.createElement('a')
        // a.download = response.data.dName + '.' + response.data.dType
        a.href = response.data.copyPath
        a.target = '_blank'
        a.click()
        const h = this.$createElement
        this.$msgbox({
          title: '下载提示',
          message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
            h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
            h('a',
              { attrs: {
                href: response.data.copyPath,
                target: '_blank',
                download: `${response.data.dName}.${response.data.dType}`,
                style: 'color: #409EFF;text-decoration:underline;'
              }}, `点击这里`),
            h('span', null, `重新下载。`)
          ]),
          showCancelButton: false,
          confirmButtonText: '关闭',
          beforeClose: (action, instance, done) => {
            done()
          }
        }).then(action => {
        })
      }).catch(() => {})
    },
    audit(n) {
      this.$confirm('此操作将再次提交售后赔款申请?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.auditLoading = true
        againAfterIndemnity({ userid: this.user.dUserid, applyid: this.infoData.asiid }).then(response => {
          this.auditLoading = false
          this.infoVisible = false
          this.$message({
            message: '售后赔款申请已提交',
            type: 'success'
          })
          this.getData()
        }).catch(() => {
          this.auditLoading = false
        })
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.shpksq-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
